
import { defineComponent, ref, onMounted, computed } from "vue";
import TaskPage from "@/components/participant/task/taskPage.vue";
import TimeLinePage from "@/components/participant/timeline/timelinePage.vue";
import RecordPage from "@/components/participant/record/recordPage.vue";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import { useStore } from "vuex";
import {
  Module as ParticipationModule,
  Actions as ParticipationActions,
  Getters as ParticipationGetters,
} from "@/store/enums/participationEnums";
import { Module, Actions, Getters } from "@/store/enums/homeEnums";

import eventStatusModel from "@/core/models/share/status.interface";
import inviteEventModel from "@/core/models/share/inviteEvent.interface";
import inviteAvailableTimeModel from "@/core/models/share/inviteAvailableTime.interface";

export default defineComponent({
  name: "ParticipantPage",
  components: {
    TaskPage: TaskPage,
    TimeLinePage: TimeLinePage,
    RecordPage:RecordPage,
  },
  setup() {
    const store = useStore();    
    const tabs = [
      {
        index: 0,
        name: "task",
        display: "Task",
        icon: "M7 16H13C13.55 16 14 15.55 14 15V7C14 6.45 13.55 6 13 6H7C6.45 6 6 6.45 6 7V15C6 15.55 6.45 16 7 16ZM7 24H13C13.55 24 14 23.55 14 23V19C14 18.45 13.55 18 13 18H7C6.45 18 6 18.45 6 19V23C6 23.55 6.45 24 7 24ZM17 24H23C23.55 24 24 23.55 24 23V15C24 14.45 23.55 14 23 14H17C16.45 14 16 14.45 16 15V23C16 23.55 16.45 24 17 24ZM16 7V11C16 11.55 16.45 12 17 12H23C23.55 12 24 11.55 24 11V7C24 6.45 23.55 6 23 6H17C16.45 6 16 6.45 16 7Z",
      },
      {
        index: 1,
        name: "timeline",
        display: "Timeline",
        icon: "M7 21H11C11.55 21 12 20.55 12 20C12 19.45 11.55 19 11 19H7C6.45 19 6 19.45 6 20C6 20.55 6.45 21 7 21ZM6 10C6 10.55 6.45 11 7 11H23C23.55 11 24 10.55 24 10C24 9.45 23.55 9 23 9H7C6.45 9 6 9.45 6 10ZM7 16H17C17.55 16 18 15.55 18 15C18 14.45 17.55 14 17 14H7C6.45 14 6 14.45 6 15C6 15.55 6.45 16 7 16Z",
      },
      {
        index: 2,
        name: "record",
        display: "Record",
        icon: "M13 3a9 9 0 0 0-9 9H1l3.89 3.89l.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7s-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18zm-1 5v5l4.25 2.52l.77-1.28l-3.52-2.09V8z",
      },
    ];
    const selectedTab = ref("task");
    store.dispatch(
      ParticipationModule.desc + ParticipationActions.LoadEventsAvailableTime
    );
    store.dispatch(
      ParticipationModule.desc + ParticipationActions.LoadEventsMyResponses
    );

    const statusHeaders = computed<Array<eventStatusModel>>(
      () => store.getters[Module.desc + Getters.EventStatuses]
    );
    const eventHeaders = computed<Array<inviteEventModel>>(
      () => store.getters[Module.desc + Getters.MyParticipantEvents]
    );
    const data = computed<Array<inviteAvailableTimeModel>>(
      () =>
        store.getters[
          ParticipationModule.desc + ParticipationGetters.MyEventsAvailableDays
        ]
    );
    const startDate = ref<Date>(new Date());

    onMounted(() => {});

    return {
      tabs,
      selectedTab,
      statusHeaders,
      eventHeaders,
      data,
      startDate,
    };
  },
});
